import React from "react";
import { Link } from "react-router-dom";
import PolicyPage, { SupportEmail } from "./PolicyPage";

function Privacy() {
  return (
    <PolicyPage title="Privacy Policy">
      <p>
        <strong>Who we are and scope</strong>
        <br />
        Tuddlepetgoods is the operator of this online storefront. This Privacy
        Policy explains how we collect, use, retain, and disclose personal
        information when you browse the website, contact us, request custom
        work, place an order, or seek after-sales support.
      </p>
      <p>
        <strong>Information you provide</strong>
        <br />
        We may collect your name, email address, telephone number, billing and
        delivery details, company name, order selections, size and customization
        choices, correspondence, return information, and photographs you send
        for support. Do not send full card numbers, security codes, passwords,
        or unnecessary identity documents by email or through the contact form.
      </p>
      <p>
        <strong>Order and payment information</strong>
        <br />
        We receive transaction details such as order number, item, amount,
        currency, payment status, and limited payment-method information from
        the payment provider. Card credentials are entered on the provider&apos;s
        hosted checkout and are not intended to be stored directly by this
        storefront. The provider processes payment data under its own privacy
        notice.
      </p>
      <p>
        <strong>Information collected automatically</strong>
        <br />
        Our systems and service providers may receive IP address, browser and
        device type, operating system, language, approximate location derived
        from IP, referring page, requested pages, timestamps, error records, and
        security logs. The storefront saves cart selections in browser local
        storage. See our <Link to="/cookies">Cookie Policy</Link>.
      </p>
      <p>
        <strong>Sources of information</strong>
        <br />
        Information comes from you, your device or browser, payment and fraud
        prevention providers, carriers, and people acting with your authority.
        If you buy for another recipient, only provide details you are permitted
        to share and tell them how we use the information.
      </p>
      <p>
        <strong>How we use information</strong>
        <br />
        We use personal information to operate the site; validate, accept,
        fulfill, deliver, and support orders; process payments and refunds;
        respond to messages; provide custom work and repairs; prevent fraud and
        misuse; protect customers and the site; maintain records; enforce our
        terms; establish or defend legal claims; comply with law; and improve
        products and customer experience.
      </p>
      <p>
        <strong>Legal bases where required</strong>
        <br />
        Depending on applicable law, processing may be based on steps requested
        before a contract, performance of a contract, compliance with legal
        obligations, consent, or legitimate interests such as security,
        customer service, fraud prevention, recordkeeping, and service
        improvement. We balance legitimate interests against affected rights.
      </p>
      <p>
        <strong>How information is disclosed</strong>
        <br />
        We disclose only information reasonably needed to providers that support
        hosting, payment, fraud screening, communications, customer service,
        order production, professional advice, fulfillment, and delivery. We may
        also disclose information where required by law, to protect rights and
        safety, to investigate misuse, with your direction, or in connection
        with a merger, financing, reorganization, or transfer of business assets.
      </p>
      <p>
        <strong>No sale or behavioral-advertising sharing</strong>
        <br />
        We do not currently sell personal information for money or use this
        storefront to share it for cross-context behavioral advertising. Details
        and request instructions are in <Link to="/privacy-choices">Privacy Choices</Link>.
      </p>
      <p>
        <strong>Retention</strong>
        <br />
        We retain information only for as long as reasonably needed for the
        purpose collected, including order fulfillment, warranties, returns,
        customer support, fraud prevention, tax, accounting, legal claims, and
        compliance. Retention varies with the record and applicable limitation
        periods. Data is deleted or de-identified when it is no longer needed,
        subject to backup cycles and legal holds.
      </p>
      <p>
        <strong>Security</strong>
        <br />
        We use reasonable administrative and technical safeguards appropriate
        to the nature of the information. No internet transmission or storage
        system is completely secure. Use a trusted device, protect your email
        account, and tell us promptly if you suspect an unauthorized order or
        message pretending to be from us.
      </p>
      <p>
        <strong>International processing</strong>
        <br />
        We and our providers may process information in countries other than
        yours. Those countries may have different privacy laws. Where required,
        we use a recognized transfer mechanism or other appropriate safeguard
        and make further information available on request.
      </p>
      <p>
        <strong>Your rights and choices</strong>
        <br />
        Depending on where you live, you may request access, correction,
        deletion, restriction, portability, or details about disclosures; object
        to certain processing; withdraw consent; or appeal a decision. We may
        verify identity and may retain information where law permits or requires.
        Visit <Link to="/privacy-choices">Privacy Choices</Link> for instructions.
      </p>
      <p>
        <strong>Children</strong>
        <br />
        The storefront is intended for adults and is not directed to children
        under 16. We do not knowingly collect a child&apos;s personal information.
        A parent or guardian who believes a child submitted information should
        contact us so we can review and take appropriate action.
      </p>
      <p>
        <strong>External services</strong>
        <br />
        Links and hosted payment or delivery services may collect information
        under their own notices. We do not control unrelated third-party sites
        and encourage you to review their privacy practices before use.
      </p>
      <p>
        <strong>Changes, questions, and complaints</strong>
        <br />
        We may update this policy to reflect operational, technology, or legal
        changes and will post the revised date. Send privacy requests or
        questions to <SupportEmail />. You may also use our{" "}
        <Link to="/complaints">complaints process</Link> or contact an applicable
        privacy authority.
      </p>
    </PolicyPage>
  );
}

export default Privacy;
